<template>
  <div class="container mt-4 mb-4">
    <div class="row">
      <div class="col-sm-8 mb-2">
        <div class="card">
          <div
            class="d-flex pt-2 pb-2 pl-4 pr-4 justify-content-between"
            style="background-color: #51381b "
          >
            <p style="color: #fff">Item Selected (2)</p>
            <!-- <div>
                <span style="color: #fff"><i class="fa fa-marker"></i>&nbsp;Deliver to</span>&nbsp;&nbsp;
                <span role="bottun" style="color: #fff"><i class="fa fa-plus"></i></span>
              </div> -->
          </div>
          <div class="row">
            <div class="p-4 col">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/krishak-404a6.appspot.com/o/products%2FRATALU.png?alt=media&token=752d5b29-ac8c-4018-86d3-63fe32887490"
                width="100px"
                height="100px"
              />
            </div>
            <div class="p-4 col">
              <div><strong>Mango</strong></div>
              <div>2 x 2kg</div>
            </div>
            <div class="p-4 col">
              <p>Delivery by tommorow, Friday</p>
            </div>
          </div>
          <div class="row">
            <div class="p-4 col">
              <span class="d-flex">
                <i
                  class="btn btn-sm btn-circle fa fa-minus"
                  style="background-color:#D0D0D2; color:#1A1824;"
                ></i>
                <span class="p-1">
                  2 kg
                </span>
                <i
                  class="btn btn-sm btn-circle fa fa-plus"
                  style="background-color:#51381b ; color:#FFFFFF;"
                ></i>
              </span>
            </div>
            <div class="p-4 col">
              <span style="color: #51381b ">₹ 22.50</span>
            </div>
            <div class="p-4 col">
              <span role="button" style="color: #51381b ">Remove</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="card" style="background-color: #E7E7E7">
          <div
            class="d-flex pt-2 pb-2 pl-4 pr-4"
            style="background-color: #51381b "
          >
            <p style="color: #fff">Price Details</p>
          </div>
          <div class="row p-3">
            <div class="col">
              Price (2 items)
            </div>
            <div class="col">
              ₹ 44.00
            </div>
          </div>
          <div class="row p-3">
            <div class="col">
              Delivery Charge
            </div>
            <div class="col">
              ₹ 50.00
            </div>
          </div>
          <div class="row p-3 mr-0 ml-0" style="background-color: #fff">
            <div class="col" style="color: #51381b ">
              Total Amount
            </div>
            <div class="col" style="color: #51381b ">
              ₹ 94.00
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container text-center mt-4">
      <b-button class="btn btn-success btn-custom">
        <span class="pt-3">
          Proceed to Checkout
        </span>
      </b-button>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.btn-custom {
  width: 220px;
  border-radius: 25px;
  height: 50px;
  padding-top: 12px;
}
</style>
